// @ts-ignore
import qc from 'qc'
import _ from 'lodash'
import { addBuiltinAnimation } from '@ps/workbench/animation'

type PasteAnimationParams = {
  // 目标节点
  targetNodes: qc.Node[]
  // 动画配置
  animations: any[]
}

/**
 * 使用预设动画配置（或动画脚本）获取新的动画脚本
 * @param targetNodes
 * @param scripts 动画脚本配置
 */
export function getAnimationScripts({
  targetNodes,
  animations,
}: PasteAnimationParams):
  | {
      [key: string]: qc.Behaviour[]
    }
  | undefined {
  if (!targetNodes || !animations) {
    throw new Error('targetNodes、currentNode、animations 为必传参数')
  }

  // 节点动画脚本列表
  let animationScripts = {}
  _.each(targetNodes, (node) => {
    const newAnimationScripts = addBuiltinAnimation({
      node,
      animations: animations,
    })
    // 为了实现历史记录功能，先添加动画脚本到节点上，然后将其从节点上移除
    // 将新增的动画脚本传给历史记录模块使用，直接添加到 node.scripts 上
    _.pullAll(node.scripts, newAnimationScripts)
    animationScripts = {
      ...animationScripts,
      [node.uuid]: newAnimationScripts,
    }
  })

  return animationScripts
}
